import { useEffect, useState } from 'react'
import {useParams} from 'react-router-dom'
import { IPermissionRecord } from '../type'
import { useQueryPermissions } from '../api/permissions'
import { useQueryRoleDetails, useUpdate } from '../api/roles'
import { List } from './List'

export default function RoleDetails() {
  const [selectedItemsUUID, setSelectedItemsUUID] = useState<string[]>([])
  const {uuid} = useParams()
  const { mutate: update } = useUpdate()
  const { data: permissions } = useQueryPermissions()
  const { data: details } = useQueryRoleDetails({ uuid })
  // console.log(permissions)
  // console.log(details)

  useEffect(() => {
  }, [selectedItemsUUID])
  useEffect(() => {
    if (!!details?.permissions) {
      setSelectedItemsUUID(
        details.permissions.map(
          (x:IPermissionRecord) => x.id
        )
      )
    }
  }, [permissions, details])

  const onItemClick = (id:string) => {
    if (!id) return

    const permissions = (selectedItemsUUID.includes(id)) ?
      [ ...selectedItemsUUID.filter((x:string) => x!==id) ]
      :
      [ ...selectedItemsUUID, id]
    ;
    setSelectedItemsUUID([...permissions])
    update({
      roleId: uuid,
      permissions,
    })
  }

  return (
    !permissions?.length ? null :
    <>
      <List keys={['name', 'displayName', 'description']}
        selectedItemsId={selectedItemsUUID}
        items={permissions.sort(
          (a:IPermissionRecord, b:IPermissionRecord) => a.displayName.localeCompare(b.displayName)
        )}
        onItemClick={onItemClick}
      />
    </>
  )
}
